import actions from "@/store/invitation/actions";
import state from "@/store/invitation/states";
import mutations from "@/store/invitation/mutations";

const InvitationModule = {
  namespaced: true,
  actions,
  state,
  mutations,
}

export default InvitationModule;